export default __webpack_public_path__ + "static/media/avatar_139.17386fad.png";